import { storefrontDeliveryEstimateSchema } from "@redotech/redo-conversion-core-common/conversion/storefront-delivery-estimate";
import * as z from "zod";

export const updateStorefrontDeliveryEstimateSettings = {
  name: "updateStorefrontDeliveryEstimateSettings" as const,
  input: z.object({ settings: storefrontDeliveryEstimateSchema }),
  output: z.null(),
};
